import {useEffect, useState} from "react";
import {DateRangeList, TimeUtils} from "../utils/time-utils";
import {UserSchema, UserSchemaExt} from "../schemas/user-schema";

export function useCoachAvailability(coachData ?: UserSchema): { availabilityEvents: DateRangeList } {
    const [availabilityEvents, setAvailabilityEvents] = useState<DateRangeList>([]);

    useEffect(() => {
        if (!coachData?.availabilityRanges) return;
        const availabilityEvents: DateRangeList = coachData?.availabilityRanges?.map(event => {
            return [
                TimeUtils.getStartOfWeek(TimeUtils.nowTz(UserSchemaExt.getTimezone(coachData))).plus(TimeUtils.weeklyHalfHourIdToOffset(event[0])),
                TimeUtils.getStartOfWeek(TimeUtils.nowTz(UserSchemaExt.getTimezone(coachData))).plus(TimeUtils.weeklyHalfHourIdToOffset(event[1], true))];
        }) ?? [];
        setAvailabilityEvents(availabilityEvents);
    }, [coachData?.availabilityRanges])

    return {
        availabilityEvents,
    }
}
